import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrown = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		viewBox: "0 0 32 32",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M7 25.75 L5.75 9.75 L11 14.5 L16 6.75 L21 14.5 L26.25 9.75 L25 25.75 Z M7.4 21.5 L24.6 21.5",
				stroke: "white",
				strokeWidth: 5.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 25.75 L5.75 9.75 L11 14.5 L16 6.75 L21 14.5 L26.25 9.75 L25 25.75 Z",
				style: { fill: "var(--sticker-pastel,#FFE29A)" }
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 9.5,
				cy: 18.25,
				r: 1.5,
				style: { fill: "var(--sticker-accent,#FBC852)" }
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 17.5,
				r: 1.5,
				style: { fill: "var(--sticker-accent,#FBC852)" }
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 22.5,
				cy: 18.25,
				r: 1.5,
				style: { fill: "var(--sticker-accent,#FBC852)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 25.75 L5.75 9.75 L11 14.5 L16 6.75 L21 14.5 L26.25 9.75 L25 25.75 Z M7.4 21.5 L24.6 21.5",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round",
				style: { stroke: "var(--sticker-dark,#B87C1F)" }
			})
		]
	});
};
export default SvgCrown;
